/* tslint:disable */
import { ChainingStudyEquipment } from './chaining-study-equipment';

/**
 */
export class OverviewChaining {
    ID_STUDY?: number;
    shape?: string;
    layer?: number;
    hasSEquipment?: number;
    StudyEquipment?: ChainingStudyEquipment[];
}



// WEBPACK FOOTER //
// /home/dfm/cryosoft/ui/src/app/api/models/overview-chaining.ts